var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaqueteria = function SvgPaqueteria(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "paqueteria_svg__Capa_2",
    viewBox: "0 0 46.78 48.78"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "paqueteria_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.78,
    height: 48.78,
    rx: 5.33,
    ry: 5.33,
    fill: "#2ad2c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3 0H15.12v17.49l7.59-2.66 7.59 2.66zM27.09 36.96h14.87v1.96H27.09zM27.09 41h6.57v1.96h-6.57z",
    fill: "#22aa9f"
  }))));
};
export default SvgPaqueteria;